export default __webpack_public_path__ + "static/media/bg01.f8fb19aa.jpg";